import styled from 'styled-components';

const RootWrapper = styled.div`
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;

  & #main {
    flex: 1 0 auto;
  }
  & #footer {
    flex-shrink: 0;
  }
`;

export default RootWrapper;
